// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: F6Ee6pDl4GK
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import Select from "../../Select"; // plasmic-import: nRNBFuAA1Vp/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicOnboardingBankingDetailsBiz.module.css"; // plasmic-import: F6Ee6pDl4GK/css
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YS4jDAKGMbE/icon
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: Ql4i0eZ6cYO/icon

createPlasmicElementProxy;

export const PlasmicOnboardingBankingDetailsBiz__VariantProps = new Array();

export const PlasmicOnboardingBankingDetailsBiz__ArgProps = new Array();

const $$ = {};

function PlasmicOnboardingBankingDetailsBiz__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "accountNum.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ``
      },
      {
        path: "routingNum.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ``
      },
      {
        path: "bankName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ``
      },
      {
        path: "accountType.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__kVlvf)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__hp53W
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__zgMp7)}>
            <div className={classNames(projectcss.all, sty.freeBox__xxRMx)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__mXiw4)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__sb75L)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__k7Cec)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg___9DD5Q)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__rIG)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__g7Z68)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__ilps)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__hOakK)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__zbvUt)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle4"}
                  data-plasmic-override={overrides.circle4}
                  className={classNames(projectcss.all, sty.circle4)}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__mCh5)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___2Lqv5)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle5"}
                  data-plasmic-override={overrides.circle5}
                  className={classNames(projectcss.all, sty.circle5)}
                />
              </div>
            </div>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__zG3Rc)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__f3UEs
                )}
              >
                {"Setup Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__uNza
                )}
              >
                {"Business Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__tp0Gx
                )}
              >
                {"Ownership"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__fQUms
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__ivpmK
                )}
              >
                {"Review & Submit"}
              </div>
            </p.Stack>
            <div
              data-plasmic-name={"vertStack"}
              data-plasmic-override={overrides.vertStack}
              className={classNames(projectcss.all, sty.vertStack)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__lvS8R
                )}
              >
                {"Add your bank to receive payouts"}
              </div>
              <div
                data-plasmic-name={"addBankButton"}
                data-plasmic-override={overrides.addBankButton}
                className={classNames(projectcss.all, sty.addBankButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__jr1Qe
                  )}
                >
                  {"Add Bank"}
                </div>
              </div>
              <div
                data-plasmic-name={"manualAdd"}
                data-plasmic-override={overrides.manualAdd}
                className={classNames(projectcss.all, sty.manualAdd)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__j5C0P
                  )}
                >
                  {"Or add it manually:"}
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__zqWaw
                  )}
                >
                  {"Account Number"}
                </div>
                <input
                  data-plasmic-name={"accountNum"}
                  data-plasmic-override={overrides.accountNum}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.accountNum
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, [
                      "accountNum",
                      "value"
                    ])(e.target.value);
                  }}
                  placeholder={``}
                  ref={ref => {
                    $refs["accountNum"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, ["accountNum", "value"]) ??
                    ""
                  }
                />

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__rPxxN
                  )}
                >
                  {"Routing Number"}
                </div>
                <input
                  data-plasmic-name={"routingNum"}
                  data-plasmic-override={overrides.routingNum}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.routingNum
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, [
                      "routingNum",
                      "value"
                    ])(e.target.value);
                  }}
                  placeholder={``}
                  ref={ref => {
                    $refs["routingNum"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, ["routingNum", "value"]) ??
                    ""
                  }
                />

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___1MEf
                  )}
                >
                  {"Bank Name"}
                </div>
                <input
                  data-plasmic-name={"bankName"}
                  data-plasmic-override={overrides.bankName}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.bankName
                  )}
                  onChange={e => {
                    p.generateStateOnChangeProp($state, ["bankName", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={``}
                  ref={ref => {
                    $refs["bankName"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    p.generateStateValueProp($state, ["bankName", "value"]) ??
                    ""
                  }
                />

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___8Ftrg
                  )}
                >
                  {"Account Type"}
                </div>
                <Select
                  data-plasmic-name={"accountType"}
                  data-plasmic-override={overrides.accountType}
                  className={classNames("__wab_instance", sty.accountType)}
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "accountType",
                      "value"
                    ])(eventArgs[0]);
                  }}
                  options={(() => {
                    const __composite = [
                      { value: null, label: null },
                      { value: null, label: null }
                    ];

                    __composite["0"]["value"] = "C";
                    __composite["0"]["label"] = "Checking";
                    __composite["1"]["value"] = "S";
                    __composite["1"]["label"] = "Savings";
                    return __composite;
                  })()}
                  value={p.generateStateValueProp($state, [
                    "accountType",
                    "value"
                  ])}
                />

                <div
                  data-plasmic-name={"manualSubmit"}
                  data-plasmic-override={overrides.manualSubmit}
                  className={classNames(projectcss.all, sty.manualSubmit)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__b5PHs
                    )}
                  >
                    {"Submit"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5",
    "vertStack",
    "addBankButton",
    "manualAdd",
    "accountNum",
    "routingNum",
    "bankName",
    "accountType",
    "manualSubmit"
  ],

  lineStack: [
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5"
  ],

  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle4: ["circle4"],
  circle5: ["circle5"],
  vertStack: [
    "vertStack",
    "addBankButton",
    "manualAdd",
    "accountNum",
    "routingNum",
    "bankName",
    "accountType",
    "manualSubmit"
  ],

  addBankButton: ["addBankButton"],
  manualAdd: [
    "manualAdd",
    "accountNum",
    "routingNum",
    "bankName",
    "accountType",
    "manualSubmit"
  ],

  accountNum: ["accountNum"],
  routingNum: ["routingNum"],
  bankName: ["bankName"],
  accountType: ["accountType"],
  manualSubmit: ["manualSubmit"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOnboardingBankingDetailsBiz__ArgProps,
          internalVariantPropNames:
            PlasmicOnboardingBankingDetailsBiz__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOnboardingBankingDetailsBiz__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOnboardingBankingDetailsBiz";
  } else {
    func.displayName = `PlasmicOnboardingBankingDetailsBiz.${nodeName}`;
  }
  return func;
}

export const PlasmicOnboardingBankingDetailsBiz = Object.assign(
  // Top-level PlasmicOnboardingBankingDetailsBiz renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle4: makeNodeComponent("circle4"),
    circle5: makeNodeComponent("circle5"),
    vertStack: makeNodeComponent("vertStack"),
    addBankButton: makeNodeComponent("addBankButton"),
    manualAdd: makeNodeComponent("manualAdd"),
    accountNum: makeNodeComponent("accountNum"),
    routingNum: makeNodeComponent("routingNum"),
    bankName: makeNodeComponent("bankName"),
    accountType: makeNodeComponent("accountType"),
    manualSubmit: makeNodeComponent("manualSubmit"),
    // Metadata about props expected for PlasmicOnboardingBankingDetailsBiz
    internalVariantProps: PlasmicOnboardingBankingDetailsBiz__VariantProps,
    internalArgProps: PlasmicOnboardingBankingDetailsBiz__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicOnboardingBankingDetailsBiz;
/* prettier-ignore-end */
